import { Link } from "@components/Link/Link";
import { styledWithInvalidProps } from "@components/Styled/StyledWithInvalidProps";
import React from "react";
import tw from "twin.macro";
import { Icon } from "../Icon";
import { BreadcrumbOutputProps, withBreadcrumb } from "./withBreadcrumb";

export const Crumbs = styledWithInvalidProps("nav")(({ float }) => [
  tw`flex flex-wrap items-center justify-start text-caption`,
  float
    ? tw`mx-auto pt-midi pb-mini md:pb-midi md:pt-maxi md:px-maxi md:max-w-2xl xl:px-tera`
    : tw`absolute z-10 top-midi left-[26px] md:top-maxi xl:left-maxi`,
]);

export const CrumbList = tw.ul`
  flex pb-micro
`;
export const CrumbListItem = tw.li`
  flex
`;
export const Crumb = styledWithInvalidProps("p")(({ pointer }) => [
  tw`capitalize`,
  pointer ? tw`border-b cursor-pointer` : null,
]);

const Chevron = tw(Icon)`
  ml-micro mr-pico w-[12px]
`;

export const Breadcrumb = withBreadcrumb(
  ({ paths, float }: BreadcrumbOutputProps) => (
    <Crumbs float={float} data-testid="breadcrumb">
      <CrumbList>
        {paths.map(({ title, url }, index) => (
          <CrumbListItem key={title}>
            {index > 0 ? (
              <Chevron role="img" name="chevron" size="none" />
            ) : null}
            {url ? (
              <Crumb as={Link} to={url} pointer={true} title={title}>
                {title}
              </Crumb>
            ) : (
              <Crumb>{title}</Crumb>
            )}
          </CrumbListItem>
        ))}
      </CrumbList>
    </Crumbs>
  ),
);
